import { icon } from "leaflet";
import {
  File,
  Home,
  DollarSign , 
  Users,
  Briefcase,
  User,
  CheckCircle,
  Inbox,
  FileText,
  Settings,
  Map,
  GitBranch,
  CheckSquare,
  
 
  
  

} from "react-feather";
import icons from "../../Data/icons";
const Passport = icons.PassPort
const Company=icons.company
const Cites= icons.City
const Earth =icons.Earth
const Contracts=icons.constract
const Requests= icons.request
const Cube= icons.cube
const Level = icons.levels
const Employment = icons.Employment
const EmployeRequest = icons.server
const RequestsTypes= icons.data
const Shifts = icons.Shifts
const Device = icons.device
const Rules = icons.role
export const MENUITEMS = [
  {
    menutitle: "",
    menucontent: "Dashboards,Widgets",
    Items: [
      {
        title: "Home",
        icon: Home,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/home`,
   
      },
      {
        title: "SystemSettings",
        icon: Settings,
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/systemsettings`,
        children:[{
          title: "Currenciens",
          type: "link",
          active: false,
          path: `${process.env.PUBLIC_URL}/systemsettings/currencies`,
        },
        {
          title: "Countries",
          type: "link",
          active: false,
          path: `${process.env.PUBLIC_URL}/systemsettings/Countries`,
        },
        {
          title: "Cites",
      
          type: "link",
          active: false,
          path: `${process.env.PUBLIC_URL}/systemsettings/cities`,
        },
        {  
          title: "Nationalites",
         
          type: "link", 
          active: false,
          path: `${process.env.PUBLIC_URL}/systemsettings/nationalities`,
        },
        {
          title: "Companies",   
          type: "link",
          active: false,
          path: `${process.env.PUBLIC_URL}/systemsettings/companies`,
        },
        {
          title: "Comapny Fields",
          type: "link",
          active: false,
          path: `${process.env.PUBLIC_URL}/systemsettings/company-fields`,
        },
          {
            title:"Rules",
            type: "link",
            active:false,
            path: `${process.env.PUBLIC_URL}/systemsettings/rules`,
          },
        {
          title:"Pages",
          type: "link",
          active:false,
          path: `${process.env.PUBLIC_URL}/systemsettings/pages`,
        },
        {
          title:"Articles",
          type: "link",
          active:false,
          path: `${process.env.PUBLIC_URL}/systemsettings/articles`,
        },
        {
          title:"Categories",
          type: "link",
          active:false,
          path: `${process.env.PUBLIC_URL}/systemsettings/categories`,
        },
        ]
         
      },
      {
      title:"Settings",
      icon:Settings,
      type:"link",
      active:false,
      path:`${process.env.PUBLIC_URL}/settings`

      },
      {
        title:"Visits",
        icon:Users,
        type:"link",
        active:false,
        path:`${process.env.PUBLIC_URL}/visits`
  
        },
        {
          title:"Holidays",
          icon:Users,
          type:"link",
          active:false,
          path:`${process.env.PUBLIC_URL}/holidays`
    
          },
      {
        title: "Attendance",
        icon: CheckCircle,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/attendance`,
      },
      {
        title: "Branches And Departments",
        icon: Cube,
        type: "sub",
        active: false,  
      
        children:[
          {
            title:"Branches",
            type: "link",
            active:false,
            path: `${process.env.PUBLIC_URL}/branches`,
          },
          {
            title:"Departments",
            type: "link",     
            active:false,
            path: `${process.env.PUBLIC_URL}/departments`,
          }
        ]
      },  
      {
        title:"Employees",
        type: "link",
        icon: User,
        active:false,
        path: `${process.env.PUBLIC_URL}/employes`,
      },
      {
        title: "Additional Settings",
        icon: Settings,
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/companysettings`,
        children:[
          {
            title:"Levels",
            type: "link",      
            active:false,
            path: `${process.env.PUBLIC_URL}/companysettings/levels`,
          },
          {
            title:"Comapny Rules",
            type: "link",      
            active:false,
            path: `${process.env.PUBLIC_URL}/companysettings/companyrules`,
          },
          {
            title:"Empolyment Types",
            type: "link",          
            active:false,
            path: `${process.env.PUBLIC_URL}/companysettings/empolymentTypes`,
          },
          {
            title:"Shifts",
            type: "link",
            active:false,
            path: `${process.env.PUBLIC_URL}/companysettings/shifts`,
          },
      
          {
            title:"Device",
            type: "link",
            active:false,
            path: `${process.env.PUBLIC_URL}/companysettings/device`,
          },
      
        
        
        
          {
            title:"Designations",
            type: "link",
            active:false,
            path: `${process.env.PUBLIC_URL}/companysettings/designations`,
          },
        
        ]
      },
      
      {
        title:"Payrolls",
        type: "link",
        active:false,
        path: `${process.env.PUBLIC_URL}/payrolls`,
      },
      { 
        title: "Contracts",
        type: "link",
        active: false, 
        path: `${process.env.PUBLIC_URL}/contracts`,
      },
      { 
        title: "Bouns",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/bouns`,
      },
      { 
        title: "Deductions",
        type: "link",  
        active: false,
        path: `${process.env.PUBLIC_URL}/deductions`,
      },
      { 
        title: "Salaries",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/salaries`,
      },
    
      { 
        title: "Requests Types",
        type: "link", 
        icon:RequestsTypes,
        active: false,
        path: `${process.env.PUBLIC_URL}/requests`,
      },
      { 
        title: "Employe Requests",
        icon:EmployeRequest,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/employerequests`,
      },
      {
        title: "Tasks",
        type: "link",
        icon:CheckSquare,
        active: false,
        path: `${process.env.PUBLIC_URL}/tasks`,
      },
 
    ],
  },
];
